import Axios from '@/utils/axios';
import Api from '@/constant/api';

export const getShopApplyInfo = async (params) => {
  return Axios.jsonGet(Api.shop.shop_apply_info, { params });
};

export const getRegisterCode = async (params) => {
  return Axios.jsonGet(Api.shop.apply_shop_code, { params });
};

export const applyShop = async (body) => {
  return Axios.jsonPost(Api.shop.apply_shop, body);
};

export const getShopInfo = async (params) => {
  return Axios.jsonGet(Api.shop.shop_info, { params });
};

export const modifyShop = async (params) => {
  return Axios.jsonPost(Api.shop.modify_shop, params);
};

export const getModifyShopCode = async (params) => {
  return Axios.jsonGet(Api.shop.modify_shop_code, { params });
};

export const verifyShopBank = async (params) => {
  return Axios.jsonPost(Api.shop.verify_shop_bank, params);
};

export const getAddressConfig = async (params) => {
  return Axios.jsonGet(Api.shop.address_config, { params });
};
